import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { Box, Grid } from "@material-ui/core";

import GiantSearchBar from "../GiantSearchBar/GiantSearchBar";
import Hero from "../Hero/Hero";
import MiddleCards from "./MiddleCards";
import OurData from "./OurData";
import FootCards from "./FootCards";

import classes from "./HomePage.module.css";

import ourDataImage from "../../assets/images/ourdata.jpg";
import { clearLocalStorage, LS_IN_CART } from "../../utils/LocalStorageUtils";

const bgImgStyle = {
  backgroundImage: `url(${ourDataImage})`,
  backgroundSize: "cover",
  backgroundPosition: "top center",
};

const HomePageContainer = (props) => {
  const { ldClient, honeycomb } = props;

  useEffect(() => {
    // on home page loading - clear local storage except these listed
    clearLocalStorage([LS_IN_CART]);
  }, []);

  return (
    <>
      <Hero />
      <Box className={classes.mainBox}>
        <GiantSearchBar honeycomb={honeycomb} ldClient={ldClient} />
        <MiddleCards />
      </Box>
      <div style={bgImgStyle}>
        <Box className={classes.mainBox} style={{ paddingBottom: "0px" }}>
          <Grid container spacing={6} style={{ padding: "10px 24px 0px" }}>
            <Grid item md={12} xs={12}>
              <OurData />
              <FootCards />
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default HomePageContainer;

HomePageContainer.defaultProps = {
  ldClient: null,
  honeycomb: null,
};

HomePageContainer.propTypes = {
  ldClient: PropTypes.shape(),
  honeycomb: PropTypes.shape(),
};
